import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";

import course02 from "../../../course/course-02/course";
import lesson0216 from "../../../lesson/course-02/lesson-16/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "f7351bb3-a589-4c69-8337-73fba620f90b",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0216),
    lesson: lesson0216,
  },
];

export default lessonLinks;
